import { useCallback } from 'react';
import { type Storage } from '@common/types/userType';

import { setStockOverflowNotificationIsOpen } from '@/redux/reducers/modalsReducer';
import { useAppDispatch } from '@/redux/store';

const useCheckStorageOverflow = (): ((
  storage: Storage,
  checkList: string[],
) => void) => {
  const dispatch = useAppDispatch();
  const openNotification = useCallback((): void => {
    const hiddenDay = localStorage.getItem('stockOverflowModalHiddenDate');

    const today = new Date();

    if (hiddenDay && hiddenDay === today.toLocaleDateString()) {
      return;
    }

    dispatch(setStockOverflowNotificationIsOpen(true));
  }, []);
  const checkStorageOverflow = useCallback(
    (storage: Storage, checkList: string[]): void => {
      const checkListSet = new Set(checkList);
      const isSomeResourceStorageOverflow = Object.entries(storage)
        .filter(([item]) => checkListSet.has(item))
        .some(([, detail]) =>
          detail?.storageLimit ? detail.value > detail.storageLimit : false,
        );

      if (isSomeResourceStorageOverflow) openNotification();
    },
    [openNotification],
  );

  return checkStorageOverflow;
};

export { useCheckStorageOverflow };
